





































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class ChartProgress extends Vue {
  @Prop({ default: 130 }) size: number
  @Prop({ default: [75] }) series: Array<any>
  @Prop({ default: '#2699fb' }) labelColor: string
  @Prop({ default: '24/40' }) label: string
  @Prop({ default: '' }) subLabel: string
  @Prop({ default: true }) labelShow: boolean
  @Prop({ default: true }) subLabelShow: boolean
  @Prop({ default: '#2699fb' }) chartColor: string
  @Prop({ default: '#2699fb' }) trackColor: string
  @Prop({ default: 'default' }) stylePosition: string
  @Prop({ default: '10px' }) fontSizeLabel: string
  @Prop({ default: '15px' }) fontSizeValue: string
  @Prop({ default: 0 }) labelOffsetY: number
  @Prop({ default: 0 }) subLabelOffsetY: number
  @Prop({ default: 0.5 }) trackOpacity: number

  chartStyles = {}
  chartOptions = {
    chart: {},
    plotOptions: {
      radialBar: {
        // startAngle: 90,
        // endAngle: 225,
        hollow: {
          margin: 0,
          size: '70%',
          // background: '#fff',
          position: 'front'
        },
        track: {
          strokeWidth: '90%',
          background: '#2699fb',
          margin: 0, // margin is in pixels
          opacity: 0.5,
          dropShadow: {
            enabled: true,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35
          }
        },

        dataLabels: {
          name: {
            show: true,
            color: '#2699fb',
            fontSize: '15px',
            offsetY: 0
          },
          value: {
            formatter: function(val, opt) {
              return ''
            },
            color: '#2699fb',
            fontSize: '10px',
            show: true,
            offsetY: 0
          }
        }
      }
    },
    colors: ['#2699fb'],
    stroke: {
      lineCap: 'round'
    },
    labels: ['24/40'],
    value: '100'
  }

  created() {
    this.chartOptions.plotOptions.radialBar.dataLabels.name.color = this.labelColor
    this.chartOptions.plotOptions.radialBar.dataLabels.value.color = this.labelColor
    this.chartOptions.plotOptions.radialBar.dataLabels.name.show = this.labelShow
    this.chartOptions.plotOptions.radialBar.dataLabels.value.show = this.subLabelShow
    this.chartOptions.plotOptions.radialBar.dataLabels.value.formatter = this.format
    this.chartOptions.plotOptions.radialBar.dataLabels.name.fontSize = this.fontSizeValue
    this.chartOptions.plotOptions.radialBar.dataLabels.value.fontSize = this.fontSizeLabel
    this.chartOptions.plotOptions.radialBar.dataLabels.name.offsetY = this.labelOffsetY
    this.chartOptions.plotOptions.radialBar.dataLabels.value.offsetY = this.subLabelOffsetY
    this.chartOptions.labels = [this.label]
    this.chartOptions.colors = [this.chartColor]
    this.chartOptions.plotOptions.radialBar.track.background = this.trackColor
    this.chartOptions.plotOptions.radialBar.track.opacity = this.trackOpacity
    this.chartStyles = {
      width: this.size - 50 + 'px',
      height: this.size - 50 + 'px'
    }
  }

  format() {
    return this.subLabel
  }
}
